import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col, Table } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";

function ProcesosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const hoy = moment().format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
  const [pedidos, setPedidos] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedPedido, setSelectedPedido] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [fechaCompromiso, setFechaCompromiso] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [precio, setPrecio] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);
  const [renglones, setRenglones] = useState([]);

  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  useEffect(() => {
    axios.get(URL_PROVEEDORES, { headers })
      .then((res) => setProveedores(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
    axios.get(URL_PEDIDOS, { headers })
      .then((res) => setPedidos(res.data.filter((a) => a.is_active === "Si" && a.status !== "Cancelado")))
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line

  // al elegir pedido, trae sus renglones (con variante) para decidir qué mandar
  function cargaPedido(idPedido) {
    setSelectedPedido(idPedido);
    setRenglones([]);
    if (!idPedido) return;
    axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`, { headers })
      .then((res) => {
        const filas = (res.data || []).map((a) => ({
          id: uuidv4(),
          articulosPedido: a._id,
          articulo: a.articulos?.[0] ? `${a.articulos?.[0]?.codigo || ""} ${a.articulos?.[0]?.nombre || ""}`.trim() : "",
          color: a.colores?.[0] ? `${a.colores?.[0]?.name}` : "",
          talla: a.tallas?.[0]?.name || "",
          idColor: a.colores?.[0]?._id || "",
          idTalla: a.tallas?.[0]?._id || "",
          pedido: a.cantidad || 0,
          yaEnviado: a.cantidadProcesos || 0,
          cantidadSalida: 0,
        }));
        setRenglones(filas);
      })
      .catch((err) => console.log(err));
  }

  const cambiaCantidad = (id, valor) => {
    setRenglones((prev) =>
      prev.map((r) => (r.id === id ? { ...r, cantidadSalida: parseFloat(valor) || 0 } : r))
    );
  };

  const totalPiezas = renglones.reduce((s, r) => s + (parseFloat(r.cantidadSalida) || 0), 0);
  const totalGeneral = totalPiezas * (parseFloat(precio) || 0);

  const guardar = (event) => {
    event.preventDefault();
    const aEnviar = renglones.filter((r) => parseFloat(r.cantidadSalida) > 0);
    if (aEnviar.length === 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura al menos una cantidad a enviar" });
      return;
    }
    const excedidos = aEnviar.filter((r) => r.cantidadSalida + r.yaEnviado > r.pedido);
    if (excedidos.length > 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: `No puedes enviar mas de lo pedido en: ${excedidos[0].articulo}` });
      return;
    }
    setValidaBoton(false);

    axios
      .post(URL_PROCESOS_SALIDA, {
        proveedores: selectedProveedor,
        pedidos: selectedPedido,
        fecha,
        fechaCompromiso,
        observaciones,
        status: "Abierto",
        totalGeneral,
        totalPiezas,
        precio: parseFloat(precio) || 0,
      }, { headers })
      .then((data) => {
        const idProceso = data.data._id;
        Promise.all(
          aEnviar.map((r) =>
            axios.post(URL_ARTICULOS_PROCESOS_SALIDA, {
              procesosSalida: idProceso,
              articulosPedido: r.articulosPedido,
              pedidos: selectedPedido,
              cantidadSalida: parseFloat(r.cantidadSalida),
              cantidadEntrada: 0,
              faltantes: parseFloat(r.cantidadSalida),
              proveedores: selectedProveedor,
              fecha,
              precio: parseFloat(precio) || 0,
              colores: r.idColor,
              tallas: r.idTalla,
            }, { headers })
          )
        ).then(() => {
          axios.post(URL_LOGS, {
            tipo: "Salida a Maquila",
            detalle: `Pedido ${selectedPedido} / ${totalPiezas} pzs`,
            user: user.id,
          }, { headers });
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => { window.location.reload(); }, 1500);
        });
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.message}` });
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_procesos ? (
        <div className="card container col-11">
          <h3 align="center">Salida a Maquila</h3>
          <Form onSubmit={guardar}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
              </Col>
              <Col md={3}>
                <Label>Fecha Compromiso</Label>
                <Input type="date" value={fechaCompromiso} required onChange={(e) => setFechaCompromiso(e.target.value)} />
              </Col>
              <Col md={3}>
                <Label>Maquilero</Label>
                <Input type="select" value={selectedProveedor} required onChange={(e) => setSelectedProveedor(e.target.value)}>
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => (<option key={a._id} value={a._id}>{a.nombre_comercial}</option>))}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Precio por Pieza</Label>
                <Input type="number" min="0" step="any" value={precio} required onChange={(e) => setPrecio(e.target.value)} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={5}>
                <Label>Pedido</Label>
                <Input type="select" value={selectedPedido} required onChange={(e) => cargaPedido(e.target.value)}>
                  <option value="">Selecciona</option>
                  {pedidos
                    .sort((a, b) => (a.idPedido > b.idPedido ? 1 : -1))
                    .map((a) => (<option key={a._id} value={a._id}>{a.idPedido} - {a.clientes?.[0]?.nombre_comercial || ""}</option>))}
                </Input>
              </Col>
              <Col md={7}>
                <Label>Observaciones</Label>
                <Input type="text" value={observaciones} required onChange={(e) => setObservaciones(e.target.value)} />
              </Col>
            </Row>
            <br />

            {renglones.length > 0 ? (
              <>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr>
                      <th className="tituloTabla">Articulo</th>
                      <th className="tituloTabla">Color</th>
                      <th className="tituloTabla">Talla</th>
                      <th className="tituloTabla" align="right">Pedido</th>
                      <th className="tituloTabla" align="right">Ya Enviado</th>
                      <th className="tituloTabla" align="right">Enviar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renglones.map((r) => (
                      <tr key={r.id}>
                        <td>{r.articulo}</td>
                        <td>{r.color}</td>
                        <td>{r.talla}</td>
                        <td align="right">{r.pedido}</td>
                        <td align="right">{r.yaEnviado}</td>
                        <td align="right" style={{ maxWidth: "110px" }}>
                          <Input type="number" min="0" step="any" value={r.cantidadSalida}
                            onChange={(e) => cambiaCantidad(r.id, e.target.value)} />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="5" align="right"><b>Total Piezas</b></td>
                      <td align="right"><b>{new Intl.NumberFormat("en-US").format(totalPiezas)}</b></td>
                    </tr>
                    <tr>
                      <td colSpan="5" align="right"><b>Total</b></td>
                      <td align="right"><b>
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalGeneral)}
                      </b></td>
                    </tr>
                  </tbody>
                </Table>
                <br />
              </>
            ) : selectedPedido ? (
              <h6 align="center">Este pedido no tiene renglones disponibles.</h6>
            ) : undefined}

            <Row>
              <Col md={12} align="center">
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">Guardar</Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>Guardar</Button>
                )}
                <Button href="/MenuProduccion" className="btn btn-danger">Regresar</Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default ProcesosSalidaCreate;
